export default "__VITE_ASSET__Dg4VHV$z__"